import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import syncService from '../services/syncService';
import apiService from '../services/apiService';
import { getFamilleLevageFromSteps } from '../services/familleLevage';
import ObservationLevageModalMobile from './ObservationLevageModalMobile';

// =====================================================
// GRILLES DE POINTS DE CONTRÔLE INTÉGRÉES
// =====================================================

// ANNEXE B5 - CHARIOTS ÉLÉVATEURS
const POINTS_CONTROLE_B5_CHARIOTS = [
  {
    numero: 1,
    titre: "ACCÈS À LA MACHINE",
    couleur: "bg-blue-600",
    points: [
      { num: "1.1", libelle: "Distances par rapport aux obstacles fixes" },
      { num: "1.2", libelle: "Lignes électriques aériennes (dispositions prises)" }
    ]
  },
  {
    numero: 2,
    titre: "ORGANES DE ROULEMENT",
    couleur: "bg-green-600",
    points: [
      { num: "2.1", libelle: "Pneumatiques ou bandages" },
      { num: "2.2", libelle: "Jantes" },
      { num: "2.3", libelle: "Chenilles (le cas échéant)" }
    ]
  },
  {
    numero: 3,
    titre: "CHÂSSIS - CONTREPOIDS",
    couleur: "bg-purple-600",
    points: [
      { num: "3.1", libelle: "Châssis" },
      { num: "3.2", libelle: "Contrepoids (fixation)" }
    ]
  },
  {
    numero: 4,
    titre: "STRUCTURE",
    couleur: "bg-orange-600",
    points: [
      { num: "4.1", libelle: "Mât - Colonnes" },
      { num: "4.2", libelle: "Tablier" },
      { num: "4.3", libelle: "Toit de protection (le cas échéant)" },
      { num: "4.4", libelle: "Dosseret de charge" }
    ]
  },
  {
    numero: 5,
    titre: "SOURCE D'ÉNERGIE",
    couleur: "bg-red-600",
    points: [
      { num: "5.1", libelle: "Moteur thermique (état général, fixation)" },
      { num: "5.2", libelle: "Batterie (fixation, état)" },
      { num: "5.3", libelle: "Câbles et connexions électriques" },
      { num: "5.4", libelle: "Canalisations hydrauliques" },
      { num: "5.5", libelle: "Réservoir de carburant" }
    ]
  },
  {
    numero: 6,
    titre: "ÉCLAIRAGE",
    couleur: "bg-yellow-600",
    points: [
      { num: "6.1", libelle: "Phares de travail" },
      { num: "6.2", libelle: "Gyrophare (le cas échéant)" },
      { num: "6.3", libelle: "Feux de signalisation" }
    ]
  },
  {
    numero: 7,
    titre: "POSTE DE CONDUITE",
    couleur: "bg-teal-600",
    points: [
      { num: "7.1", libelle: "Siège (fixation, réglages)" },
      { num: "7.2", libelle: "Ceinture de sécurité" },
      { num: "7.3", libelle: "Rétroviseurs" },
      { num: "7.4", libelle: "Avertisseur sonore" },
      { num: "7.5", libelle: "Indicateurs et voyants" }
    ]
  },
  {
    numero: 8,
    titre: "COMMANDES DE SERVICE ET DE MANŒUVRE",
    couleur: "bg-indigo-600",
    points: [
      { num: "8.1", libelle: "Volant de direction" },
      { num: "8.2", libelle: "Pédales (accélérateur, frein)" },
      { num: "8.3", libelle: "Leviers de commande hydraulique" },
      { num: "8.4", libelle: "Commandes de sens de marche" },
      { num: "8.5", libelle: "Frein de parking" }
    ]
  },
  {
    numero: 9,
    titre: "SUSPENSIONS - VÉRINS - CHAÎNES",
    couleur: "bg-pink-600",
    points: [
      { num: "9.1", libelle: "Vérins de levage" },
      { num: "9.2", libelle: "Vérins d'inclinaison" },
      { num: "9.3", libelle: "Chaînes de levage (usure, tension)" },
      { num: "9.4", libelle: "Flexibles hydrauliques" }
    ]
  },
  {
    numero: 10,
    titre: "MÉCANISMES",
    couleur: "bg-cyan-600",
    points: [
      { num: "10.1", libelle: "Transmission" },
      { num: "10.2", libelle: "Direction" },
      { num: "10.3", libelle: "Freinage de service" },
      { num: "10.4", libelle: "Circuits hydrauliques" }
    ]
  },
  {
    numero: 11,
    titre: "DISPOSITIFS DE SÉCURITÉ",
    couleur: "bg-amber-600",
    points: [
      { num: "11.1", libelle: "Limiteur de charge (le cas échéant)" },
      { num: "11.2", libelle: "Dispositif de fin de course haute" },
      { num: "11.3", libelle: "Dispositif anti-écrasement pieds" },
      { num: "11.4", libelle: "Système d'immobilisation (clé)" },
      { num: "11.5", libelle: "Arrêt d'urgence" },
      { num: "11.6", libelle: "Avertisseur de recul" }
    ]
  },
  {
    numero: 12,
    titre: "ÉQUIPEMENTS - ACCESSOIRES",
    couleur: "bg-slate-600",
    points: [
      { num: "12.1", libelle: "Fourches (usure, fissures)" },
      { num: "12.2", libelle: "Tablier à déplacement latéral" },
      { num: "12.3", libelle: "Rallonges de fourches" },
      { num: "12.4", libelle: "Autres accessoires" }
    ]
  },
  {
    numero: 13,
    titre: "PRESCRIPTIONS DIVERSES",
    couleur: "bg-rose-600",
    points: [
      { num: "13.1", libelle: "Plaque de capacité" },
      { num: "13.2", libelle: "Marquage CE / Conformité" },
      { num: "13.3", libelle: "Notice d'instructions" },
      { num: "13.4", libelle: "Carnet de maintenance" }
    ]
  },
  {
    numero: 14,
    titre: "ÉPREUVES - ESSAIS",
    couleur: "bg-emerald-600",
    points: [
      { num: "14.1", libelle: "Essai de fonctionnement à vide" },
      { num: "14.2", libelle: "Essai en charge" },
      { num: "14.3", libelle: "Essai des dispositifs de sécurité" }
    ]
  }
];

// ANNEXE B1 - PALANS, PONTS ROULANTS, PORTIQUES
const POINTS_CONTROLE_B1_PALANS = [
  {
    numero: 1,
    titre: "INSTALLATION",
    couleur: "bg-blue-600",
    points: [
      { num: "1.1", libelle: "Distances par rapport aux obstacles fixes" },
      { num: "1.2", libelle: "Lignes électriques aériennes" },
      { num: "1.3", libelle: "Voie de roulement (rails, fixations)" }
    ]
  },
  {
    numero: 2,
    titre: "ACCÈS",
    couleur: "bg-green-600",
    points: [
      { num: "2.1", libelle: "Passerelles" },
      { num: "2.2", libelle: "Échelles, escaliers" },
      { num: "2.3", libelle: "Garde-corps" }
    ]
  },
  {
    numero: 3,
    titre: "STRUCTURE - CHARPENTE",
    couleur: "bg-purple-600",
    points: [
      { num: "3.1", libelle: "Poutres principales" },
      { num: "3.2", libelle: "Sommiers" },
      { num: "3.3", libelle: "Assemblages, soudures" }
    ]
  },
  {
    numero: 4,
    titre: "MÉCANISMES",
    couleur: "bg-orange-600",
    points: [
      { num: "4.1", libelle: "Treuil de levage" },
      { num: "4.2", libelle: "Réducteurs" },
      { num: "4.3", libelle: "Freins" },
      { num: "4.4", libelle: "Moteurs" }
    ]
  },
  {
    numero: 5,
    titre: "CÂBLES - CHAÎNES - CROCHETS",
    couleur: "bg-red-600",
    points: [
      { num: "5.1", libelle: "Câble de levage" },
      { num: "5.2", libelle: "Chaîne de levage" },
      { num: "5.3", libelle: "Crochet, linguet de sécurité" },
      { num: "5.4", libelle: "Moufle" }
    ]
  },
  {
    numero: 6,
    titre: "DISPOSITIFS DE SÉCURITÉ",
    couleur: "bg-yellow-600",
    points: [
      { num: "6.1", libelle: "Limiteur de charge" },
      { num: "6.2", libelle: "Fins de course" },
      { num: "6.3", libelle: "Butées" },
      { num: "6.4", libelle: "Arrêt d'urgence" }
    ]
  }
];

// ANNEXE B6 - PEMP (Nacelles)
const POINTS_CONTROLE_B6_PEMP = [
  {
    numero: 1,
    titre: "INSTALLATION",
    couleur: "bg-blue-600",
    points: [
      { num: "1.1", libelle: "Distances par rapport aux obstacles" },
      { num: "1.2", libelle: "Lignes électriques" },
      { num: "1.3", libelle: "Sol, stabilité" }
    ]
  },
  {
    numero: 2,
    titre: "CHÂSSIS - STABILISATEURS",
    couleur: "bg-green-600",
    points: [
      { num: "2.1", libelle: "Châssis" },
      { num: "2.2", libelle: "Stabilisateurs" },
      { num: "2.3", libelle: "Indicateur de niveau" }
    ]
  },
  {
    numero: 3,
    titre: "STRUCTURE",
    couleur: "bg-purple-600",
    points: [
      { num: "3.1", libelle: "Bras articulés/télescopiques" },
      { num: "3.2", libelle: "Mât" },
      { num: "3.3", libelle: "Tourelle" }
    ]
  },
  {
    numero: 4,
    titre: "PANIER / NACELLE",
    couleur: "bg-orange-600",
    points: [
      { num: "4.1", libelle: "Plancher" },
      { num: "4.2", libelle: "Garde-corps" },
      { num: "4.3", libelle: "Portillon" },
      { num: "4.4", libelle: "Points d'ancrage EPI" }
    ]
  },
  {
    numero: 5,
    titre: "COMMANDES",
    couleur: "bg-red-600",
    points: [
      { num: "5.1", libelle: "Commandes en nacelle" },
      { num: "5.2", libelle: "Commandes au sol" },
      { num: "5.3", libelle: "Arrêt d'urgence" }
    ]
  },
  {
    numero: 6,
    titre: "DISPOSITIFS DE SÉCURITÉ",
    couleur: "bg-yellow-600",
    points: [
      { num: "6.1", libelle: "Limiteur de charge" },
      { num: "6.2", libelle: "Limiteur de moment" },
      { num: "6.3", libelle: "Fins de course" },
      { num: "6.4", libelle: "Dispositif anti-écrasement" }
    ]
  }
];

// Mapping des codes annexes vers les grilles
const GRILLES_PAR_ANNEXE = {
  'B1': POINTS_CONTROLE_B1_PALANS,
  'B5': POINTS_CONTROLE_B5_CHARIOTS,
  'B6': POINTS_CONTROLE_B6_PEMP
};

// Grille par défaut
const GRILLE_DEFAUT = POINTS_CONTROLE_B5_CHARIOTS;

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '16px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '16px'
  },
  familyBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    borderRadius: '12px',
    color: 'white',
    marginBottom: '16px'
  },
  statsBar: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px'
  },
  statItem: {
    flex: 1,
    padding: '12px',
    background: 'white',
    borderRadius: '12px',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  statNumber: {
    fontSize: '20px',
    fontWeight: '700'
  },
  statLabel: {
    fontSize: '11px',
    color: '#6b7280'
  },
  section: {
    marginBottom: '16px',
    background: 'white',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 16px',
    color: 'white',
    cursor: 'pointer'
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '700',
    margin: 0
  },
  sectionStats: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  sectionBadge: {
    background: 'rgba(255,255,255,0.3)',
    padding: '4px 8px',
    borderRadius: '8px',
    fontSize: '11px',
    fontWeight: '600'
  },
  pointsList: {
    borderTop: '1px solid #e5e7eb'
  },
  pointItem: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '12px 16px',
    borderBottom: '1px solid #f3f4f6',
    gap: '12px'
  },
  pointNumber: {
    minWidth: '45px',
    fontSize: '13px',
    fontWeight: '700',
    color: '#f59e0b'
  },
  pointContent: {
    flex: 1,
    minWidth: 0
  },
  pointLabel: {
    fontSize: '13px',
    color: '#374151',
    lineHeight: 1.4
  },
  pointActions: {
    display: 'flex',
    gap: '6px',
    flexShrink: 0
  },
  addObsBtn: {
    background: '#fef3c7',
    color: '#92400e'
  },
  obsBadges: {
    display: 'flex',
    gap: '6px',
    flexWrap: 'wrap',
    marginTop: '6px'
  },
  obsBadge: {
    background: '#dc2626',
    color: 'white',
    padding: '2px 6px',
    borderRadius: '6px',
    fontSize: '10px',
    fontWeight: '700'
  },
  actionBtn: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    cursor: 'pointer'
  },
  conformeBtn: {
    background: '#dcfce7',
    color: '#16a34a'
  },
  conformeBtnActive: {
    background: '#16a34a',
    color: 'white'
  },
  nonConformeBtn: {
    background: '#fee2e2',
    color: '#dc2626'
  },
  nonConformeBtnActive: {
    background: '#dc2626',
    color: 'white'
  },
  naBtn: {
    background: '#f3f4f6',
    color: '#6b7280'
  },
  naBtnActive: {
    background: '#6b7280',
    color: 'white'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #16a34a, #15803d)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

function Etape4PointsControleMobile({ mission, onBack, onSave }) {
  const [sections, setSections] = useState([]);
  const [expandedSections, setExpandedSections] = useState({});
  const [observations, setObservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [codeAnnexe, setCodeAnnexe] = useState('B5');
  
  // Modal observation
  const [showObsModal, setShowObsModal] = useState(false);
  const [selectedPoint, setSelectedPoint] = useState(null);

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const etape1 = await inspectionStorage.getStep(mission.id, 'etape_1_infos_generales_levage');
      const etape2 = await inspectionStorage.getStep(mission.id, 'etape_2_caracteristiques_techniques_levage');
      const familleLevage = getFamilleLevageFromSteps(etape1, etape2);
      const familleCode = familleLevage.code || 'B5';
      setCodeAnnexe(familleCode);

      let grillePoints = null;
      const grillesCache = await inspectionStorage.get('grilles_points_controle_levage');
      
      if (grillesCache && grillesCache[familleCode]) {
        grillePoints = grillesCache[familleCode];
        console.log('✅ Grille trouvée dans le cache pour', familleCode);
      }

      // 1bis. Si pas de grille en cache, tenter de la recharger depuis l'API
      if (!grillePoints) {
        const apiResult = await apiService.getGrillesPointsControleLevage();
        if (apiResult.success && apiResult.grilles) {
          await inspectionStorage.set('grilles_points_controle_levage', apiResult.grilles);
          await inspectionStorage.set('grilles_levage_updated_at', new Date().toISOString());
          if (apiResult.grilles[familleCode]) {
            grillePoints = apiResult.grilles[familleCode];
            console.log('✅ Grille chargée depuis l\'API pour', familleCode);
          }
        }
      }
      
      // 2. Fallback local si toujours pas de grille
      if (!grillePoints) {
        grillePoints = GRILLES_PAR_ANNEXE[familleCode] || GRILLE_DEFAUT;
        if (grillePoints) {
          console.warn('⚠️ Grille locale utilisée pour', familleCode);
        }
      }

      // 3. Si pas de grille, afficher une erreur
      if (!grillePoints) {
        console.error('❌ Aucune grille trouvée pour', familleCode, '- veuillez synchroniser');
        setSections([]);
        setLoading(false);
        return;
      }
      
      // Transformer en sections
      const mappedSections = grillePoints.map((sec, idx) => ({
        id: `section-${idx}`,
        titre: sec.titre,
        couleur: sec.couleur || 'bg-blue-600',
        points: sec.points.map(p => ({
          id: `point-${p.num}`,
          numero: p.num,
          libelle: p.libelle
        }))
      }));
      console.log('📋 Sections chargées:', mappedSections.length, 'sections,', mappedSections.reduce((sum, s) => sum + s.points.length, 0), 'points');
      setSections(mappedSections);

      // Charger observations existantes
      const obsData = await inspectionStorage.getStep(mission.id, 'etape_11_observations');
      if (obsData?.observations) {
        setObservations(obsData.observations);
      }

    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const handleAddObservation = (point, sectionTitre) => {
    setSelectedPoint({ ...point, sectionTitre });
    setShowObsModal(true);
  };

  const handleSaveObservation = async (observation) => {
    const obsData = await inspectionStorage.getStep(mission.id, 'etape_11_observations');
    const currentObservations = obsData?.observations || observations;
    const dernierNumero = obsData?.dernier_numero
      ? Number(obsData.dernier_numero) || 0
      : currentObservations.length > 0
        ? Math.max(...currentObservations.map(o => o.numero || 0))
        : 0;
    const nouveauNumero = dernierNumero + 1;

    const newObservation = {
      ...observation,
      numero: nouveauNumero,
      created_date: new Date().toISOString()
    };

    const updatedObservations = [...currentObservations, newObservation];
    setObservations(updatedObservations);

    await inspectionStorage.saveStep(mission.id, 'etape_11_observations', {
      observations: updatedObservations,
      dernier_numero: nouveauNumero
    });

    setShowObsModal(false);
    setSelectedPoint(null);
  };

  const getObservationsForPoint = (pointNum) => {
    return observations.filter(obs => 
      obs.element_ref?.type === 'point_controle' && 
      obs.element_ref?.point_numero === pointNum
    );
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_4_points_controle_levage', {
        code_annexe: codeAnnexe,
        updated_at: new Date().toISOString()
      });
      console.log('✅ Étape 4 levage sauvegardée');
      if (onSave) onSave({ code_annexe: codeAnnexe });
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  // Couleur de section
  const getSectionColor = (couleur) => {
    const colorMap = {
      'bg-blue-600': '#2563eb',
      'bg-green-600': '#16a34a',
      'bg-purple-600': '#9333ea',
      'bg-orange-600': '#ea580c',
      'bg-red-600': '#dc2626',
      'bg-teal-600': '#0d9488',
      'bg-indigo-600': '#4f46e5',
      'bg-pink-600': '#db2777',
      'bg-yellow-600': '#ca8a04',
      'bg-cyan-600': '#0891b2',
      'bg-amber-600': '#d97706',
      'bg-slate-600': '#475569',
      'bg-rose-600': '#e11d48',
      'bg-emerald-600': '#059669'
    };
    return colorMap[couleur] || '#f59e0b';
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#fffbeb' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#f59e0b', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#92400e', fontWeight: '500' }}>Chargement grille {codeAnnexe}...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  // Message si aucune grille disponible
  if (sections.length === 0) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <button style={styles.backBtn} onClick={onBack}>← Retour</button>
          <h1 style={styles.headerTitle}>Points de contrôle</h1>
          <span></span>
        </div>
        <div style={{ padding: '40px 20px', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ color: '#92400e', marginBottom: '12px' }}>Grille non disponible</h2>
          <p style={{ color: '#78716c', marginBottom: '24px' }}>
            La grille de points de contrôle pour l'annexe <strong>{codeAnnexe}</strong> n'est pas disponible en local.
          </p>
          <p style={{ color: '#78716c', fontSize: '14px' }}>
            👉 Retournez à l'accueil et cliquez sur <strong>"Sync"</strong> pour télécharger les grilles.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Points de contrôle</h1>
        <button style={styles.backBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        {/* Badge famille */}
        <div style={styles.familyBadge}>
          <span style={{ fontSize: '24px' }}>📋</span>
          <div>
            <div style={{ fontWeight: '700', fontSize: '15px' }}>Annexe {codeAnnexe}</div>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>Arrêté du 1er mars 2004</div>
          </div>
        </div>

        {/* Sections */}
        {sections.map(section => {
          const isExpanded = expandedSections[section.id];
          const sectionColor = getSectionColor(section.couleur);

          return (
            <div key={section.id} style={styles.section}>
              {/* Header section */}
              <div 
                style={{ ...styles.sectionHeader, background: sectionColor }}
                onClick={() => toggleSection(section.id)}
              >
                <h3 style={styles.sectionTitle}>{section.titre}</h3>
                <span style={{ fontSize: '18px' }}>{isExpanded ? '▲' : '▼'}</span>
              </div>

              {/* Points */}
              {isExpanded && (
                <div style={styles.pointsList}>
                  {section.points.map(point => {
                    const pointObs = getObservationsForPoint(point.numero);

                    return (
                      <div key={point.id} style={styles.pointItem}>
                        <div style={styles.pointNumber}>{point.numero}</div>
                        <div style={styles.pointContent}>
                          <div style={styles.pointLabel}>{point.libelle}</div>
                          {pointObs.length > 0 && (
                            <div style={styles.obsBadges}>
                              {pointObs.map(obs => (
                                <span key={obs.numero} style={styles.obsBadge}>
                                  N° {obs.numero}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                        <div style={styles.pointActions}>
                          <button
                            style={{ ...styles.actionBtn, ...styles.addObsBtn }}
                            onClick={() => handleAddObservation(point, section.titre)}
                            title="Ajouter une observation"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Bouton sauvegarder */}
      <div style={styles.saveSection}>
        <button 
          style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }} 
          onClick={handleSave} 
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>

      {/* Modal observation */}
      {showObsModal && selectedPoint && (
        <ObservationLevageModalMobile
          isOpen={showObsModal}
          onClose={() => {
            setShowObsModal(false);
            setSelectedPoint(null);
          }}
          onSave={handleSaveObservation}
          point={selectedPoint}
          codeAnnexe={codeAnnexe}
        />
      )}
    </div>
  );
}

export default Etape4PointsControleMobile;